import { Segmented } from "antd";
import { api, unwrap } from "@/api/client";
import { useAuth } from "@/auth/AuthProvider";
import { useI18n, type Locale } from "@/i18n";

/**
 * ID / EN switch (App Flow §12): changes the interface in place without leaving
 * the page. When signed in, the choice is saved to the account.
 */
export function LanguageSwitch() {
  const { locale, setLocale, t } = useI18n();
  const { me, refetchMe } = useAuth();

  const change = async (value: Locale) => {
    setLocale(value);
    if (me) {
      try {
        await unwrap(api.PATCH("/v1/me", { body: { name: me.user.name, locale: value } }));
        void refetchMe();
      } catch {
        // The interface already switched; saving the preference can wait.
      }
    }
  };

  return (
    <Segmented<Locale>
      size="small"
      value={locale}
      onChange={change}
      aria-label={t("common.language")}
      options={[
        { label: "ID", value: "id", title: t("lang.id") },
        { label: "EN", value: "en", title: t("lang.en") },
      ]}
    />
  );
}
